import React, { useEffect, useState, useRef } from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import { useStores } from '../../hooks/use-stores';
import { LoginLoc } from '../../loc/login';
import { loc } from '../../lib/loc';

import PreloadButton from '../../interface/PreloadButton';
import ErrorMessage from '../../interface/ErrorMessage';
import InputWithCountrySelect from '../UI/InputWithCountrySelect';

const LoginForm = observer(() => {
    const { LoginStore: store } = useStores();
    const [phone, setPhone] = useState('');
    const { loader, errorMessage, setErrorMessage, login, success } = store || {};
    const { state: { errorMessage: error } = {} } = useLocation();

    const passwordRef = useRef();

    const auth = e => {
        e.preventDefault();
        login(phone, passwordRef.current.value);
    };

    useEffect(() => {
        error && setErrorMessage(error);
        // eslint-disable-next-line
    }, []);

    return (
        <form className="login-form" onSubmit={auth}>
            {success && <Redirect to="/" />}
            {errorMessage && <ErrorMessage message={errorMessage} />}
            <div className="login-form__wrap-items">
                <InputWithCountrySelect setPhone={setPhone} placeholder={loc(LoginLoc.loginPlaceholder)} />

                <input
                    ref={passwordRef}
                    className="login-form__input"
                    placeholder={loc(LoginLoc.passwordPlaceholder)}
                    type="password"
                    autoComplete="current-password"
                    required
                />
                <Link className="login-form__forgot-password" to="/login/recovery">
                    {loc(LoginLoc.forgotPassword)}
                </Link>
                <div className="login-form__wrap-login-btn">
                    <PreloadButton style={{ border: 'none' }} className="login-form__login-btn" isLoad={loader}>
                        {loc(LoginLoc.signIn)}
                    </PreloadButton>
                </div>
                <div className="login-form__registration">
                    <span>{loc(LoginLoc.dontHaveAccount)}</span>
                    <Link to="/register">{loc(LoginLoc.register)}</Link>
                </div>
            </div>
        </form>
    );
});

export default LoginForm;
